import { userService } from './../../Services/userService';
import { TravelPolicyMdl } from './../../Models/TravelPolicyMdl';
import { MedmalPolicyMdl } from './../../Models/MedmalPolicyMdl';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../Models/restURL';
import { policyModel } from '../../Models/policyModel';
import { RegModel } from '../../Models/RegModel';
import { PolicyDashboardMdl } from '../../Models/PolicyDashboardMdl';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { motorProposalService } from '../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';
import { mdlPoliciesList_DH } from '../../Models/mdlPoliciesList_DH';
import { mdlAddSequnceNoReq } from '../../Models/mdlAddSequnceNoReq';
import { APIService } from '../../Services/api.service';
import { LanguageService } from '../../Services/languageService';
import { Subscription } from 'rxjs';
import { mdlAnnouncementRes } from '../../Models/mdlAnnouncementRes';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'Policy',
  templateUrl: './Policy.html',
  styleUrls: ['./Policy.css']
})
export class Policy {

  @ViewChild('tab2') tab2: ElementRef;


  public License: boolean;
  public OTP: boolean;
  public Vehicle: boolean;
  public Count: number = 1;
  public Motor: boolean;
  public SelectedType: string;
  public IsMotor: boolean;
  public IsTravel: boolean;
  public IsMedMal: boolean;
  public IsHome: boolean;
  public ModelInsurance: string;
  public PolicyList: Array<policyModel> = new Array<policyModel>();
  public MotorPolicyList: Array<policyModel> = new Array<policyModel>();
  public CurrentPolicy: policyModel = new policyModel();
  public objCancellationDet: policyModel = new policyModel();
  public objCancellationTravelDet: TravelPolicyMdl = new TravelPolicyMdl()
  public isShowLoading: boolean;
  public regObj: RegModel = new RegModel();
  public policyDashbordList: Array<PolicyDashboardMdl> = new Array<PolicyDashboardMdl>();
  public motorPolicyDashboard: PolicyDashboardMdl = new PolicyDashboardMdl();
  public medmalPolicyDashboard: PolicyDashboardMdl = new PolicyDashboardMdl();
  public travelPolicyDashboard: PolicyDashboardMdl = new PolicyDashboardMdl();
  // public MedmalPolicyList: Array<MedmalPolicyMdl> = new Array<MedmalPolicyMdl>();
  public TravelPolicyList: Array<TravelPolicyMdl> = new Array<TravelPolicyMdl>()
  public MedmalSubPolicyList: Array<MedmalPolicyMdl> = new Array<MedmalPolicyMdl>();
  public TravelSubPolicyList: Array<TravelPolicyMdl> = new Array<TravelPolicyMdl>();
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  public DomesticPoliciesList: Array<mdlPoliciesList_DH> = new Array<mdlPoliciesList_DH>();


  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  public MedmalPolicyList :any;

  Lng: string;
  LngSubscription: Subscription;
  public Announcement: mdlAnnouncementRes = new mdlAnnouncementRes();

  constructor(private EncriptService: motorProposalService, public toastr: ToastsManager, vcr: ViewContainerRef, private router: Router, private http: HttpClient, private url: restURL, private userinfo: userService,
    private APISer: APIService,private lngService: LanguageService, public Translate: TranslateService) {
    //<<<<<<FOR TOASTER START>>>>>
    this.toastr.setRootViewContainerRef(vcr);
    if (sessionStorage.getItem("Policy") == "True") {
      if (sessionStorage.getItem("Language") == 'en') {
        this.toastr.info('Welcome ' + sessionStorage.getItem("InsuredName"), 'Login Success!', { showCloseButton: true });
      }
      else {
        this.toastr.info('Welcome ' + sessionStorage.getItem("InsuredNameAr"), 'Login Success!', { showCloseButton: true });
      }
      sessionStorage.removeItem("Policy");
    }
    //<<<<<<FOR TOASTER END>>>>>
    this.Lng = this.lngService.getLanguage() || 'en';
    this.GetAnnouncement();
    this.MotorDashboard();
    this.getPolicies();
    this.getMedmalPolicies();
    this.getTravelPolicies();
    this.bindDashBoard();
    // this.GetPoliciesList_DH();


  }

  GetAnnouncement() {
    this.isShowLoading = true;
    let Req = {
      UserId: "331",
      Channel: "OLD_B2C",
      PageType: "Welcome"
    };
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(Req));
    this.http.post<mdlPayloadResponse>(
      this.url.baseURL + "MotorOnline/GetAnnouncement",
      this.objPayloadRequest,
      this.userinfo.getHttpOptions()
    )
    .toPromise()
    .then((result) => {
      this.isShowLoading = false;
      this.objPayloadResponse = result;
      this.Announcement = JSON.parse(
        JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse))
      );
      
      if (this.Announcement.StatusCode == "S") {
        let stHTML : string = this.Lng == "en" ? this.Announcement.EngMessage : this.Announcement.ArMessage;
        let Title : string = this.Announcement.Title;

        Swal({
          title: this.Translate.instant(Title),
          html: this.Translate.instant(stHTML),
          type: "info",
          background: 'white',
          customClass: 'swal-wide !important',
          width: '25%',
          confirmButtonText: 'Ok'
        });
      }
    },
    (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
    });
  }

  getPolicies() {
    this.isShowLoading = true;
    this.regObj.RegNo = sessionStorage.getItem("RegNo");
    this.regObj.token = sessionStorage.getItem("token");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.regObj));
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getPolicies", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.objPayloadResponse = result;

      let objResObj: Array<policyModel> = new Array<policyModel>();
      objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      if (objResObj.length > 0) {
        if (objResObj[0].regNo != this.regObj.RegNo) {
          Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
          this.router.navigate(['BeforeLogin/NewReg']);
          return;
        }
      }

      this.PolicyList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));



      this.MotorPolicyList = this.PolicyList;
      this.isShowLoading = false;
    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
      });

  }

  GetPoliciesList_DH() {
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(sessionStorage.getItem("RegNo")));

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/GetPoliciesList_DH", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise()
      .then((result) => {
        this.objPayloadResponse = result;
        this.DomesticPoliciesList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

        if (this.DomesticPoliciesList.length > 0) {
          if (this.DomesticPoliciesList[0].RegNo != Number(this.regObj.RegNo)) {
            Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
            this.router.navigate(['BeforeLogin/NewReg']);
            return;
          }
        }

      }, (error) => {
        this.userinfo.checkTokenStatus(error);

      });
  }

  getMedmalPolicies_OLD() {
    this.isShowLoading = true;
    this.regObj.RegNo = sessionStorage.getItem("RegNo");
    this.regObj.token = sessionStorage.getItem("token");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.regObj));
    //this.http.post<Array<MedmalPolicyMdl>>(this.url.baseURL + "/PolicySettings/getMedmalPolicies", this.regObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getMedmalPolicies", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      // this.MedmalPolicyList = result;
      // this.MedmalSubPolicyList = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.MedmalPolicyList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      this.MedmalSubPolicyList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
      });
  }

  getTravelPolicies() {
    this.isShowLoading = true;
    this.regObj.RegNo = sessionStorage.getItem("RegNo");
    this.regObj.token = sessionStorage.getItem("token");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.regObj));

    //this.http.post<Array<TravelPolicyMdl>>(this.url.baseURL + "/PolicySettings/getTravelPolicies", this.regObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getTravelPolicies", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;

      // this.TravelPolicyList = result;
      // this.TravelSubPolicyList = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.TravelPolicyList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      this.TravelSubPolicyList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
 
      //NewLine End 
    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
      });
  }

  MotorDashboard() {
    this.ModelInsurance = "Motor Insurance";
    this.IsMotor = true;
    this.IsTravel = false;
    this.IsMedMal = false;
    this.IsHome = false;

  }

  TravelDashboard() {
    this.ModelInsurance = "Travel Insurance";
    this.IsMotor = false;
    this.IsTravel = true;
    this.IsMedMal = false;
    this.IsHome = false;
  }

  MedicalMalDashboard() {
    this.ModelInsurance = "MedicalMal Insurance";
    this.IsMotor = false;
    this.IsTravel = false;
    this.IsMedMal = true;
    this.IsHome = false;
  }

  HomeDashboard() {
    this.ModelInsurance = "Home Insurance";
    this.IsMotor = false;
    this.IsTravel = false;
    this.IsMedMal = false;
    this.IsHome = true;
  }

  goForRenew(policy) {
    this.CurrentPolicy = policy;
    sessionStorage.setItem("renewObj", this.EncriptService.EncriptObject(JSON.stringify(this.CurrentPolicy.renewObj)));
    this.router.navigate(['/NewDashboard/CompRenewalPolicy']);
  }

  MotorPolicies(type) {

    document.getElementById("tab1head").className = "active";
    document.getElementById("tab2head").className = "";
    document.getElementById("tab3head").className = "";

    document.getElementById("home").className = "tab-pane active in";
    document.getElementById("profile").className = "tab-pane fade";
    document.getElementById("messages").className = "tab-pane fade";




    if (type == "A") {
      this.MotorPolicyList = Object.assign([], this.PolicyList).filter(t => t.reStatus == "A" || t.reStatus == "R");
      //this.MotorPolicyList=this.PolicyList.filter(t=>t.reStatus=="A" || t.reStatus=="R");
    }
    else if (type == "P") {

    }
    else if (type == "R") {
      this.MotorPolicyList = Object.assign([], this.PolicyList).filter(t => t.reStatus == "R");
      //this.MotorPolicyList=this.PolicyList.filter(t=>t.reStatus=="R");
    }
    else if (type == "C") {
      this.MotorPolicyList = Object.assign([], this.PolicyList).filter(t => t.PolicyStatus == "CANCELLED");
    }
    else {
      this.MotorPolicyList = this.PolicyList;
    }
  }

  TravelPolicies(type) {

    document.getElementById("tab1head").className = "";
    document.getElementById("tab2head").className = "active";
    document.getElementById("tab3head").className = "";

    document.getElementById("home").className = "tab-pane fade out";
    document.getElementById("profile").className = "tab-pane active in";
    document.getElementById("messages").className = "tab-pane fade out";



    if (type == "A") {
      this.TravelSubPolicyList = Object.assign([], this.TravelPolicyList).filter(
        t => t.PolicyStatus == "A");
    }
    else if (type == 'T') {
      this.TravelSubPolicyList = this.TravelPolicyList;
    }
    else {
      this.TravelSubPolicyList = null;

    }
  }

  MedmalPolicies(type) {

    document.getElementById("tab1head").className = "";
    document.getElementById("tab2head").className = "";
    document.getElementById("tab3head").className = "active";

    document.getElementById("home").className = "tab-pane fade out";
    document.getElementById("profile").className = "tab-pane fade out";
    document.getElementById("messages").className = "tab-pane active in";



    if (type == "A") {
      this.MedmalSubPolicyList = Object.assign([], this.MedmalPolicyList).filter(
        t => t.PolicyStatus == "A");

    }
    else if (type == "T") {
      this.MedmalSubPolicyList = this.MedmalPolicyList;
    }
    else {
      this.MedmalSubPolicyList = null;

    }
  }

  public bindDashBoard() {
    this.isShowLoading = true;
    this.regObj.RegNo = sessionStorage.getItem("RegNo");
    this.regObj.token = "";

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.regObj));

    //this.http.post<Array<PolicyDashboardMdl>>(this.url.baseURL + "/PolicySettings/getPolicyDashboardInfo", this.regObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getPolicyDashboardInfo", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.policyDashbordList = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.policyDashbordList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End




      this.motorPolicyDashboard = this.policyDashbordList.filter(t => t.ProductCode == "5515")[0];
      this.medmalPolicyDashboard = this.policyDashbordList.filter(t => t.ProductCode == "5014")[0];
      this.travelPolicyDashboard = this.policyDashbordList.filter(t => t.ProductCode == "6001")[0];

      this.isShowLoading = false;
    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
      });
  }

  public Motor_Cancellation(Policy) {
    //sessionStorage.setItem("MotorCancelObj", JSON.stringify(Policy));
    sessionStorage.setItem("MotorCancelObj", this.EncriptService.EncriptObject(JSON.stringify(Policy)));
    this.router.navigate(['/NewDashboard/Motor_Cancellation']);
  }

  CancellationDetails(policy) {
    this.objCancellationDet = policy; 
  }

  goForUpgrade(policy) {
    this.CurrentPolicy = policy;

    sessionStorage.setItem("UpgradePolicy", JSON.stringify(this.CurrentPolicy.PolicyNo));
    this.router.navigate(['/NewDashboard/Upgrade']);
  }


  AddSequenceNo(policy) {
   // this.CurrentPolicy = policy;
    let objAddSeq: mdlAddSequnceNoReq =new  mdlAddSequnceNoReq();
    objAddSeq.RegNo=policy.regNo;
    objAddSeq.PolicyNo=policy.PolicyNo;
    objAddSeq.InsuredName=policy.InsName;
    objAddSeq.CustomId=policy.renewObj.CustomID;
    objAddSeq.ChassisNo=policy.ChasissNo;

    
    // sessionStorage.setItem("AddSeqPolicy", JSON.stringify(objAddSeq));
    sessionStorage.setItem("AddSeqPolicy", this.EncriptService.EncriptObject(JSON.stringify(objAddSeq)));
    this.router.navigate(['/NewDashboard/AddSeqNo']);
  }

  AddDrivers(policy){
    let objAddSeq: mdlAddSequnceNoReq =new  mdlAddSequnceNoReq();
    objAddSeq.RegNo=policy.regNo;
    objAddSeq.PolicyNo=policy.PolicyNo;
    objAddSeq.InsuredName=policy.InsName;
    objAddSeq.CustomId=policy.renewObj.CustomID;
    objAddSeq.SequenceNo=policy.renewObj.SequenceNo;

    
    // sessionStorage.setItem("AddSeqPolicy", JSON.stringify(objAddSeq));
    sessionStorage.setItem("AddDrivers", this.EncriptService.EncriptObject(JSON.stringify(objAddSeq)));
    this.router.navigate(['/NewDashboard/AddDrivers']);
  }


  async getMedmalPolicies() {
    let Req = {
      RegNo : sessionStorage.getItem("RegNo"),
      InsuredId: sessionStorage.getItem("IqamaNo"),
      Lng : sessionStorage.getItem("Lng"),
    }
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/GetMedmalPolicyList", Req)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    // if(APIRes[1].StatusCode=="F"){
    //   Swal(APIRes[1].StatusDesc, "", "error")
    // }
    // let Res = APIRes[1];
    // if(Res.st.StatusCode == "S"){
    //   this.MedmalPolicyList = Res.MedmalPolicyList;
    // }else{
    //   Swal(Res.st.StatusDescEn, "", "error")
    // }
  }

  StatusCss(Status:any){
    if (Status == "Active") {
      return { 'color': 'green'}
  }
  if (Status == "Expired") {
      return { 'color': 'red'}
  }
  return {}
  }


  TravelCancellation(obj:any){ 
    sessionStorage.setItem("TrvaelCancelObj", this.EncriptService.EncriptObject(JSON.stringify(obj)));
    this.router.navigate(['/NewDashboard/TravelCancellation']);
  }

  CancellationDetailsTravel(obj:any){ 
    this.objCancellationTravelDet = obj; 
  }

  TravelAddEndorsement(obj:any){ 
    sessionStorage.setItem("objEndReq", this.EncriptService.EncriptObject(JSON.stringify(obj)));
    this.router.navigate(['/NewDashboard/TravelAddEndorsement']);
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Policies/Policy.ts